import clsx from "clsx";

function Skeleton({ className, ...props }) {
	return (
		<div
			className={clsx("bg-gray-200 animate-pulse rounded-md", className)}
			{...props}
		/>
	);
}

export { Skeleton };
